var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnermarkernew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9112_726)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 127,
    height: 127,
    rx: 63.5,
    fill: "#FF9D00",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9112_726)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9112_726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 89,
    height: 89
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 89,
    height: 89,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9112_726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.872 102.88C68.8213 102.88 67.9406 102.524 67.2298 101.814C66.5191 101.103 66.1637 100.222 66.1637 99.1714C66.1637 98.7387 66.2564 98.2906 66.4418 97.8271C66.6272 97.3635 66.9053 96.9464 67.2762 96.5755L83.1293 80.7224C83.5001 80.3516 83.6856 79.9035 83.6856 79.3781C83.6856 78.8528 83.5001 78.4047 83.1293 78.0339C82.7585 77.663 82.3104 77.4931 81.785 77.524C81.2597 77.5549 80.8116 77.7557 80.4408 78.1266L64.6803 93.887C64.3095 94.2578 63.9078 94.5359 63.4751 94.7214C63.0425 94.9068 62.579 94.9995 62.0845 94.9995C61.0338 94.9995 60.1531 94.6441 59.4423 93.9333C58.7316 93.2226 58.3762 92.3418 58.3762 91.2911C58.3762 90.6731 58.4689 90.1632 58.6543 89.7615C58.8397 89.3597 59.0869 89.0043 59.396 88.6953L75.2491 72.8422C75.6199 72.4714 75.8053 72.0387 75.8053 71.5443C75.8053 71.0498 75.6199 70.6172 75.2491 70.2464C74.8783 69.8755 74.4456 69.6901 73.9512 69.6901C73.4567 69.6901 73.0241 69.8755 72.6533 70.2464L56.8001 86.0068C56.4293 86.3776 56.0276 86.6557 55.5949 86.8411C55.1623 87.0266 54.6678 87.1193 54.1116 87.1193C53.1227 87.1193 52.2574 86.7484 51.5158 86.0068C50.7741 85.2651 50.4033 84.3998 50.4033 83.4109C50.4033 82.9165 50.496 82.453 50.6814 82.0203C50.8668 81.5877 51.1449 81.1859 51.5158 80.8151L67.2762 65.0547C67.647 64.6839 67.8324 64.2358 67.8324 63.7104C67.8324 63.1851 67.647 62.737 67.2762 62.3661C66.9053 61.9953 66.4727 61.8099 65.9783 61.8099C65.4838 61.8099 65.0512 61.9953 64.6803 62.3661L48.9199 78.2193C48.6109 78.5283 48.2401 78.7755 47.8074 78.9609C47.3748 79.1464 46.8494 79.2391 46.2314 79.2391C45.1807 79.2391 44.3 78.8837 43.5892 78.1729C42.8784 77.4622 42.523 76.5814 42.523 75.5307C42.523 75.0363 42.6158 74.5727 42.8012 74.1401C42.9866 73.7075 43.2647 73.3057 43.6355 72.9349L61.8064 54.7641C62.4862 54.0842 63.3361 53.7752 64.3559 53.837C65.3757 53.8988 66.2255 54.2696 66.9053 54.9495L78.2158 66.2599C78.8956 66.9398 79.6991 67.4806 80.6262 67.8823C81.5533 68.284 82.4803 68.4849 83.4074 68.4849C85.3852 68.4849 87.1158 67.7896 88.5991 66.399C90.0824 65.0083 90.8241 63.2314 90.8241 61.0682C90.8241 60.203 90.6696 59.3068 90.3606 58.3797C90.0515 57.4526 89.4953 56.5873 88.6918 55.7839L75.9908 43.0828C75.3109 42.403 74.8628 41.6613 74.6465 40.8578C74.4302 40.0543 74.5383 39.2818 74.971 38.5401C75.5272 37.613 76.238 36.9332 77.1033 36.5005C77.9685 36.0679 78.9265 35.8516 79.9772 35.8516C81.2751 35.8516 82.604 36.1606 83.9637 36.7786C85.3234 37.3967 86.5595 38.262 87.672 39.3745L103.34 55.1349C104.452 56.2474 105.271 57.4835 105.796 58.8432C106.322 60.203 106.585 61.779 106.585 63.5714C106.585 64.8075 106.306 66.059 105.75 67.326C105.194 68.5931 104.39 69.7519 103.34 70.8026L72.4678 101.767C71.9734 102.262 71.5408 102.571 71.1699 102.694C70.7991 102.818 70.3665 102.88 69.872 102.88ZM35.7553 69.9682C34.581 69.103 33.7003 68.0677 33.1132 66.8625C32.526 65.6573 32.2324 64.3748 32.2324 63.0151C32.2324 61.5936 32.526 60.203 33.1132 58.8432C33.7003 57.4835 34.5501 56.2474 35.6626 55.1349L51.3303 39.3745C52.381 38.3238 53.5399 37.5203 54.8069 36.9641C56.0739 36.4078 57.4182 36.1297 58.8397 36.1297C60.3849 36.1297 61.8836 36.4078 63.3361 36.9641C64.7885 37.5203 66.0401 38.3238 67.0908 39.3745L86.096 58.3797C86.405 58.6887 86.6677 59.075 86.884 59.5385C87.1003 60.0021 87.2085 60.4811 87.2085 60.9755C87.2085 62.0262 86.8531 62.9069 86.1423 63.6177C85.4316 64.3285 84.5508 64.6839 83.5001 64.6839C83.0057 64.6839 82.5267 64.5757 82.0632 64.3594C81.5996 64.1431 81.2133 63.8804 80.9043 63.5714L69.5012 52.2609C68.0797 50.8394 66.3336 50.1286 64.2632 50.1286C62.1927 50.1286 60.4467 50.8394 59.0251 52.2609L41.596 69.6901C40.7925 70.4936 39.85 70.9108 38.7684 70.9417C37.6868 70.9726 36.6824 70.6481 35.7553 69.9682Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9112_726",
    x: 0,
    y: 0,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9112_726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9112_726",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9112_726",
    x: 26.2324,
    y: 29.8516,
    width: 94.3516,
    height: 87.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9112_726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9112_726",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnermarkernew);
export default __webpack_public_path__ + "static/media/partnermarkernew.4e48763f0bc77aa818b132df4685d07b.svg";
export { ForwardRef as ReactComponent };